module.exports = __webpack_public_path__ + "static/media/checkboxInstall2pub.d34bc0b8.svg";